import { render, staticRenderFns } from "./MarketsList.vue?vue&type=template&id=8db1b042"
import script from "./MarketsList.vue?vue&type=script&lang=js"
export * from "./MarketsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports